import { State } from "@prisma/client";

/** The states Marble operates in. */
export const MARBLE_STATES = [
  State.NY,
  State.NJ,
  State.OH,
  State.AZ,
] as const satisfies State[];

export type MarbleState = (typeof MARBLE_STATES)[number];

/** Full display name for every `State` enum value (all US states/territories
 * plus Marble's non-geographic "states" for armed-forces addresses), not
 * just the ones Marble operates in. */
export const StateToStr: Record<State, string> = {
  [State.AA]: "Armed Forces Americas",
  [State.AE]: "Armed Forces Europe, Middle East, Africa, and Canada",
  [State.AP]: "Armed Forces Pacific",
  [State.AL]: "Alabama",
  [State.AK]: "Alaska",
  [State.AS]: "American Samoa",
  [State.AZ]: "Arizona",
  [State.AR]: "Arkansas",
  [State.CA]: "California",
  [State.CO]: "Colorado",
  [State.CT]: "Connecticut",
  [State.DE]: "Delaware",
  [State.DC]: "District Of Columbia",
  [State.FM]: "Federated States Of Micronesia",
  [State.FL]: "Florida",
  [State.GA]: "Georgia",
  [State.GU]: "Guam",
  [State.HI]: "Hawaii",
  [State.ID]: "Idaho",
  [State.IL]: "Illinois",
  [State.IN]: "Indiana",
  [State.IA]: "Iowa",
  [State.KS]: "Kansas",
  [State.KY]: "Kentucky",
  [State.LA]: "Louisiana",
  [State.ME]: "Maine",
  [State.MH]: "Marshall Islands",
  [State.MD]: "Maryland",
  [State.MA]: "Massachusetts",
  [State.MI]: "Michigan",
  [State.MN]: "Minnesota",
  [State.MS]: "Mississippi",
  [State.MO]: "Missouri",
  [State.MT]: "Montana",
  [State.NE]: "Nebraska",
  [State.NV]: "Nevada",
  [State.NH]: "New Hampshire",
  [State.NJ]: "New Jersey",
  [State.NM]: "New Mexico",
  [State.NY]: "New York",
  [State.NC]: "North Carolina",
  [State.ND]: "North Dakota",
  [State.MP]: "Northern Mariana Islands",
  [State.OH]: "Ohio",
  [State.OK]: "Oklahoma",
  [State.OR]: "Oregon",
  [State.PW]: "Palau",
  [State.PA]: "Pennsylvania",
  [State.PR]: "Puerto Rico",
  [State.RI]: "Rhode Island",
  [State.SC]: "South Carolina",
  [State.SD]: "South Dakota",
  [State.TN]: "Tennessee",
  [State.TX]: "Texas",
  [State.UT]: "Utah",
  [State.VT]: "Vermont",
  [State.VI]: "Virgin Islands",
  [State.VA]: "Virginia",
  [State.WA]: "Washington",
  [State.WV]: "West Virginia",
  [State.WI]: "Wisconsin",
  [State.WY]: "Wyoming",
};
